const musicLinksPT = {
    "view": {
        "table": {
            "title": "Sua lista de links de música",
            "column": {
                "releaseName": "Nome do Lançamento",
                "artists": "Artistas",
                "owner": "Proprietário",
                "created": "Criado",
                "musicLink": "Link de Música",
                "action": "Ação"
            },
            "button": {
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "message": {
                "linkCopied": "Link copiado para a área de transferência!"
            }
        },
        "modal": {
            "edit": {
                "header": "Editar {{musicLinkName}}?",
                "body": "Tem certeza de que deseja editar este link de música?"
            },
            "delete": {
                "header": "Excluir {{musicLinkName}}?",
                "body": "Tem certeza de que deseja excluir este link de música?"
            }
        },
        "message": {
            "success": "Link de música foi removido!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "mlAllowanceSpent": "Você gastou sua cota de links de música. Para criar mais links de música, atualize sua conta ou entre em contato com nossa equipe de suporte.",
            "subscriptionFeatureUnavailable": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para aproveitar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>renove</1> sua assinatura para aproveitar este recurso.",
            "moduleAccessRestricted": "Você não tem acesso a este módulo, entre em contato com a equipe de suporte para mais informações."
        }
    },
    "add": {
        "title": "Adicionar Link de Música",
        "form": {
            "label": {
                "source": "Fonte",
                "subUser": "Sub-Usuário",
                "release": "Lançamento",
                "artwork": "Arte",
                "releaseName": "Nome do Lançamento",
                "upcEan": "UPC/EAN",
                "artistName": "Nome do Artista",
                "urlPart1": "Parte 1 do URL",
                "urlPart2": "Parte 2 do URL",
                "musicLinkUrl": "Seu URL de link de música é",
                "searchBy": "Pesquisar Por",
                "upcNumber": "Número UPC",
                "storeReleaseUrl": "URL de Lançamento na Loja",
                "colorCustomisation": "Personalização de Cor",
                "premadeColors": "Cores Prontas",
                "customColors": "Cores Personalizadas",
                "buttonStyle": "Estilo do Botão",
                "headerBackground": "Fundo do Cabeçalho",
                "singleColor": "Cor Única",
                "gradient": "Gradiente",
                "playerControlsColor": "Cor dos Controles do Player",
                "titleColor": "Cor do Título",
                "descriptionColor": "Cor da Descrição",
                "buttonColor": "Cor do Botão",
                "buttonHoverColor": "Cor do Hover do Botão",
                "buttonTextColor": "Cor do Texto do Botão"
            },
            "placeholder": {
                "subUser": "Selecionar Sub-usuário...",
                "release": "Selecionar Lançamento",
                "releaseUpc": "Digite o Número UPC/EAN do Lançamento, ex.: 5055964352523",
                "releaseStoreUrl": "Digite o URL de Lançamento na Loja, ex.: open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ou www.deezer.com/en/album/413370367",
                "urlPart1": "Selecionar Parte 1 do URL"
            },
            "help_text": {
                "subUser": "Nota: Use este menu suspenso apenas se quiser adicionar um link de música para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado.",
                "release": "Nota: Você só pode selecionar lançamentos que estão <strong>Distribuídos.</strong>",
                "releaseUpc": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify ou Deezer.",
                "releaseStoreUrl": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify ou Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Lançamento de Link de Música Existente",
                    "externalRelease": "Lançamento Externo"
                },
                "buttonStyle": {
                    "outlined": "Contornado",
                    "filled": "Preenchido"
                }
            },
            "button": {
                "reset": "Redefinir",
                "createNew": "Criar Novo?",
                "submit": "Enviar"
            },
            "validation": {
                "formInvalid": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "storeUrlRequired": "URL do {{store}} é obrigatório",
                "storeUrlValid": "Por favor, adicione um URL válido do {{store}}."
            }
        },
        "message": {
            "success": "Link de música foi adicionado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "fetchingReleaseDetails": "Buscando detalhes do lançamento..."
        }
    },
    "update": {
        "title": "Editar Link de Música",
        "form": {
            "label": {
                "source": "Fonte",
                "release": "Lançamento",
                "artwork": "Arte",
                "releaseName": "Nome do Lançamento",
                "upcEan": "UPC/EAN",
                "artistName": "Nome do Artista",
                "urlPart1": "Parte 1 do URL",
                "urlPart2": "Parte 2 do URL",
                "musicLinkUrl": "Seu URL de link de música é",
                "searchBy": "Pesquisar Por",
                "upcNumber": "Número UPC",
                "storeReleaseUrl": "URL de Lançamento na Loja",
                "colorCustomisation": "Personalização de Cor",
                "premadeColors": "Cores Prontas",
                "customColors": "Cores Personalizadas",
                "buttonStyle": "Estilo do Botão",
                "headerBackground": "Fundo do Cabeçalho",
                "singleColor": "Cor Única",
                "gradient": "Gradiente",
                "playerControlsColor": "Cor dos Controles do Player",
                "titleColor": "Cor do Título",
                "descriptionColor": "Cor da Descrição",
                "buttonColor": "Cor do Botão",
                "buttonHoverColor": "Cor do Hover do Botão",
                "buttonTextColor": "Cor do Texto do Botão"
            },
            "placeholder": {
                "release": "Selecionar Lançamento",
                "releaseUpc": "Digite o Número UPC/EAN do Lançamento, ex.: 5055964352523",
                "releaseStoreUrl": "Digite o URL de Lançamento na Loja, ex.: open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ou www.deezer.com/en/album/413370367",
                "urlPart1": "Selecionar Parte 1 do URL"
            },
            "help_text": {
                "release": "Nota: Você só pode selecionar lançamentos que estão <strong>Distribuídos.</strong>",
                "releaseUpc": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify ou Deezer.",
                "releaseStoreUrl": "Nota: Use este menu suspenso apenas se quiser adicionar um Lançamento que já está no Spotify ou Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Lançamento de Link de Música Existente",
                    "externalRelease": "Lançamento Externo"
                },
                "buttonStyle": {
                    "outlined": "Contornado",
                    "filled": "Preenchido"
                }
            },
            "button": {
                "reset": "Redefinir",
                "createNew": "Criar Novo?",
                "submit": "Enviar"
            },
            "validation": {
                "formInvalid": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "storeUrlRequired": "URL do {{store}} é obrigatório",
                "storeUrlValid": "Por favor, adicione um URL válido do {{store}}."
            }
        },
        "message": {
            "success": "Link de música foi atualizado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "fetchingReleaseDetails": "Buscando detalhes do lançamento..."
        }
    },
    "storeLinksRow": {
        "title": "Links da Loja",
        "label": {
            "store": "Loja",
            "link": "Link"
        },
        "button": {
            "remove": "Remover"
        },
        "model": {
            "addStore": {
                "header": "Adicionar Loja",
                "body": "Por favor, escolha a loja desejada na lista abaixo:",
                "option": {
                    "mainStores": "Lojas Principais",
                    "otherStores": "Outras Lojas"
                },
                "button": {
                    "add": "Adicionar Loja",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Arquivos de Pré-visualização",
        "label": {
            "preview": "Pré-visualização",
            "artistName": "Nome do artista",
            "trackName": "Nome da faixa"
        },
        "audioNotSupported": "Seu navegador não suporta o elemento de áudio."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Escolha o Serviço de Música",
            "track": "Faixa",
            "artist": "Artista",
            "time": "Tempo",
            "others": "Outros"
        },
        "button": {
            "play": "Reproduzir"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Buscando Estatísticas do Link de Música"
        },
        "topServices": {
            "title": "Principais Serviços",
            "subtitle": "CLIQUE POR SERVIÇO",
            "table": {
                "column": {
                    "store": "Loja",
                    "noOfVisits": "Total de Visitas",
                    "noOfVisitsPct": "Total de Visitas %"
                },
                "label": {
                    "otherStores": "Outras Lojas"
                }
            }
        },
        "topTracks": {
            "title": "Principais Faixas",
            "subtitle": "CLIQUE POR FAIXA",
            "table": {
                "column": {
                    "trackName": "Nome da Faixa",
                    "artistName": "Nome do Artista",
                    "noOfPlays": "Número de Execuções",
                    "noOfPlaysPct": "Número de Execuções %"
                }
            }
        },
        "topTerritories": {
            "title": "Principais Territórios",
            "subtitle": "CLIQUE POR TERRITÓRIO",
            "table": {
                "column": {
                    "territory": "Território",
                    "noOfViews": "Número de Visualizações",
                    "noOfViewsPct": "Número de Visualizações %"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Principais Tipos de Dispositivos",
            "subtitle": "CLIQUE POR TIPO DE DISPOSITIVO"
        },
        "topOperatingSystems": {
            "title": "Principais Sistemas Operacionais",
            "subtitle": "CLIQUE POR SO",
            "chart": {
                "label": {
                    "noOfViews": "Número de Visualizações : ",
                    "operatingSystems": "Sistema Operacional"
                }
            }
        },
        "topBrowsers": {
            "title": "Principais Navegadores",
            "subtitle": "CLIQUE POR NAVEGADOR",
            "table": {
                "column": {
                    "browser": "Navegador",
                    "noOfViewsPct": "Número de Visualizações (%)"
                }
            }
        }
    }
};

export default musicLinksPT;